import React from 'react';
import { CheckIcon, MinusIcon, XIcon } from 'lucide-react';
import type { Density, DisclosureField } from '../../types/disclosure';
interface ValueProps {
  field: DisclosureField;
}
function FieldValue({
  field
}: ValueProps) {
  const {
    value,
    type
  } = field;
  if (value === null || value === '') {
    return <span className="inline-flex items-center gap-1 text-slate-400" data-id="element-8" data-mp="9shcz90y8oyc">
        <MinusIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-9" data-mp="3raa7s8ewuqen" />
        <span className="sr-only" data-id="element-10" data-mp="3r7xitbaqjfs3">No value</span>
      </span>;
  }
  if (type === 'yesno') {
    const isYes = value === 'Yes';
    return <span className={['inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold ring-1 ring-inset', isYes ? 'bg-emerald-50 text-emerald-800 ring-emerald-200' : 'bg-slate-100 text-slate-700 ring-slate-200'].join(' ')} data-id="element-11" data-mp="3i9vkx4mat391">
        {isYes ? <CheckIcon className="h-3 w-3" aria-hidden="true" data-id="element-12" data-mp="3d9prpk0dr8ou" /> : <XIcon className="h-3 w-3" aria-hidden="true" data-id="element-13" data-mp="29fdjdxd2w81n" />}
        {value}
      </span>;
  }
  if (type === 'certified') {
    return <span className="inline-flex items-center gap-1 rounded-full bg-blue-50 px-2 py-0.5 text-xs font-semibold text-blue-800 ring-1 ring-inset ring-blue-200" data-id="element-14" data-mp="24jogbk1uo90l">
        <CheckIcon className="h-3 w-3" aria-hidden="true" data-id="element-15" data-mp="2djbk2ci1xqwt" />
        {value}
      </span>;
  }
  return <span className="tabular-nums" data-id="element-16" data-mp="1pt8vw7h9d53h">{value}</span>;
}
interface FieldListProps {
  fields: DisclosureField[];
  density: Density;
  showApiNames: boolean;
  dimmed?: boolean;
}
export function FieldList({
  fields,
  density,
  showApiNames,
  dimmed = false
}: FieldListProps) {
  const rowPadding = density === 'compact' ? 'py-1' : 'py-2';
  const textSize = density === 'compact' ? 'text-[13px]' : 'text-sm';
  return <dl className="divide-y divide-slate-100" data-id="element-17" data-mp="170dc054v9hfu">
      {fields.map(field => <div key={`${field.api}-${field.label}`} className={`grid grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)] items-baseline gap-3 ${rowPadding}`} data-id="element-18" data-mp="121tq24q9w5nh">
          <dt className={`${textSize} leading-5 text-slate-500`} data-id="element-19" data-mp="373nvhst65yee">
            {field.label}
            {showApiNames && <span className="mt-0.5 block truncate font-mono text-[10px] leading-4 text-slate-400" data-id="element-20" data-mp="3bw8pauc2sbhx">
                {field.object ? `${field.object}.` : ''}
                {field.api}
              </span>}
          </dt>
          <dd className={`${textSize} leading-5 font-medium ${dimmed ? 'text-slate-400' : 'text-slate-900'}`} data-id="element-21" data-mp="2j8crfmarsdjk">
            <FieldValue field={field} data-id="element-22" data-mp="2t3mxqm87b735" />
            {field.note && <span className="mt-0.5 block text-[11px] font-normal leading-4 text-slate-400" data-id="element-23" data-mp="2x6ja3v75e6yn">
                {field.note}
              </span>}
          </dd>
        </div>)}
    </dl>;
}